import { Checkbox } from "components/common/Checkbox/Checkbox";
import { setSettings } from "store/features/memeGenerator/actions";
import type { TextBox } from "store/features/memeGenerator/types";
import { useAppDispatch } from "store/store";

interface CapsLockProps {
    id: TextBox["id"];
    forceCaps: TextBox["forceCaps"];
}

export const CapsLock = ({ id, forceCaps }: CapsLockProps) => {
    const dispatch = useAppDispatch();
    function handleChange(value: boolean) {
        dispatch(
            setSettings({
                id,
                forceCaps: value,
            }),
        );
    }
    return <Checkbox label={`ALL CAPS`} defaultIsChecked={forceCaps} handleChange={handleChange} />;
};
